<div class="mat-elevation-z5">
  <div class="uf-dialog-header">
    <mat-toolbar color="primary">
      <h1 class="mat-title">{{title}}</h1>
      <div class="uf-filler"></div>
      <button matSuffix mat-icon-button (click)="showSearch()" matTooltip="Zoeken" aria-label="Zoeken">
        <mat-icon svgIcon="magnify"></mat-icon>
      </button>
    </mat-toolbar>
  </div>
  <div mat-dialog-content class="no-padding">
    @if (searchField) {
      <form class="search" [formGroup]="filterForm" (ngSubmit)="loadData()">
        <mat-form-field>
          <mat-label>Zoeken</mat-label>
          <input #searchInput matInput type="text" formControlName="name">
          <button matSuffix mat-icon-button type="submit" aria-label="Zoeken">
            <mat-icon svgIcon="magnify"></mat-icon>
          </button>
        </mat-form-field>
      </form>
    }
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Naam</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.name}}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="select(row)"></mat-row>
    </mat-table>
    @if (dataSource.data.length === 0) {
      <div class="not-found">
        - Er zijn geen resultaten gevonden -
      </div>
    }
  </div>
  <div mat-dialog-actions>
    <div>
      <mat-paginator [length]="dataSource.records" [pageSizeOptions]=pageSizeOptions></mat-paginator>
    </div>
    <div>
      <button mat-button (click)="close()" cdkFocusInitial>Annuleer</button>
    </div>
  </div>
</div>
